import LootBoxModal from "./LootBoxModal";

export default LootBoxModal;
